import { Icon } from '@chemist4u/newt-components';
import { cn } from '@lib/util/cn';
import LocalizedClientLink from '@modules/common/components/localized-client-link';
import TrustIndicators from './trust-indicators';

const NAV_LINKS = [
  { href: '/faqs', label: 'FAQs' },
  { href: '/how-it-works', label: 'How It Works' },
] as const;

type MainNavPanelProps = {
  showLevel2: boolean;
  onShowLevel2: () => void;
  onClose: () => void;
};

const MainNavPanel = ({
  showLevel2,
  onShowLevel2,
  onClose,
}: MainNavPanelProps) => (
  <nav
    className={cn(
      'absolute inset-0 overflow-y-auto transition-transform duration-300 ease-in-out',
      showLevel2 ? '-translate-x-full' : 'translate-x-0',
    )}
    aria-label="Main navigation"
    aria-hidden={showLevel2}
    inert={showLevel2}
  >
    <div className="flex flex-col min-h-full">
      <div>
        <button
          type="button"
          onClick={onShowLevel2}
          aria-expanded={showLevel2}
          aria-controls="side-menu-level2"
          className="flex items-center cursor-pointer justify-between w-full px-4 py-4 border-b border-brand-neutral-200 text-fg-neutral-strong hover:bg-surface-neutral-subtle transition-colors"
        >
          <span>Treatments &amp; Conditions</span>
          <Icon
            name="arrowRight"
            size="20"
            className="text-brand-neutral-500"
            aria-hidden="true"
          />
        </button>
        {NAV_LINKS.map(({ href, label }) => (
          <LocalizedClientLink
            key={href}
            href={href}
            onClick={onClose}
            className="flex items-center w-full px-4 py-4 border-b border-brand-neutral-200 text-fg-neutral-strong hover:bg-surface-neutral-subtle transition-colors"
          >
            {label}
          </LocalizedClientLink>
        ))}
      </div>
      <div className="flex-1" />
      <TrustIndicators />
    </div>
  </nav>
);

export default MainNavPanel;
